import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FileItemProps } from "apis/file";

export interface FileState {
    loading: boolean;
    list: {
        folderId?: number;
        data: FileItemProps[];
    };
    item: {
        data?: FileItemProps;
    };
}

const initialState: FileState = {
    loading: false,
    list: {
        data: [],
    },
    item: {
    }
};

interface IndexProps {
    data: FileItemProps[];
    folderId?: number;
}

interface ItemProps {
    data?: FileItemProps;
}

export const fileSlice = createSlice({
    name: "file",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.folderId = action.payload.folderId;
        },
        upload: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = [
                ...state.list.data.filter(d => d.folder?.id === state.list.folderId),
                ...action.payload.data.filter(d => d.folder?.id === state.list.folderId)
            ];
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
        remove: (state, action: PayloadAction<{ ids: number[] }>) => {
            state.loading = false;
            state.list.data = state.list.data.filter(file => !action.payload.ids.includes(file.id))

        },
    },
});

export const { loading, endLoading, index, upload, find, create, update, remove } = fileSlice.actions;
export default fileSlice.reducer;
